<script setup lang="ts">
import { useDeleteCase } from '@/data/Cases/useDeleteCase'
import { useCaseStore } from '@/modules/Cases/useCaseStore'
import { toast } from '@/shared/toast'
import ConfirmationDialog from '@/uiKit/ConfirmationDialog.vue'
import { useRouter } from 'vue-router'

const props = defineProps<{ caseId: string; workspaceId: string }>()

const open = defineModel<boolean>('open', { required: true })

const router = useRouter()
const caseStore = useCaseStore()
const { mutate: deleteCase } = useDeleteCase({
  onSuccess: (deletedId) => {
    if (deletedId === caseStore.activeCaseId) {
      toast.success('Case deleted')
      router.push({ name: 'WorkspaceCases' })
    }
  },
  onError: (error) => {
    if (error.status !== 404) {
      toast.error('Failed to delete case')
    }
  },
})

async function onConfirm() {
  open.value = false
  deleteCase({ caseId: props.caseId, workspaceId: props.workspaceId })
}
</script>

<template>
  <ConfirmationDialog
    :open="open"
    title="Delete this case?"
    description="This case will be deleted immediately. You can't undo this action."
    @confirm="onConfirm"
    @close="open = false"
  />
</template>
